import {
  Box, useMediaQuery,
} from '@mui/material'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import OfoqThemeBtn from '../Buttons/OfoqThemeBtn.jsx'
import { isNotEmpty } from '../../utils/helpers'
import { userAuthChangePassword, userCustomerAdminAuthChangePassword } from '../../redux/features/userAuth/userAuthThunk'
import FormModalContainer from './FormModalContainer.jsx'
import OfoqPasswordField from '../Forms/OfoqPasswordField.jsx'
import ConfirmationModalContainer from './ConfirmationModalContainer.jsx'
import FinishModalContainer from './FinishModalContainer.jsx'
import UseTranslation from '../../hooks/UseTranslation.jsx'
import { changePasswordModalData, resetPasswordModalData } from '../../utils/modalDataContainer'

const ChangePasswordModal = ({
  formModalState,
  setFormModalState,
  isResetAdmin,
  userId,
}) => {
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const [password, setPassword] = useState(null)
  const [newPassword, setNewPassword] = useState(null)
  const [repeatPassword, setRepeatPassword] = useState(null)
  const [validPassword, setValidPassword] = useState(false)
  const [isFormNotValid, setIsFormNotValid] = useState(true)
  const [confirmationModalState, setConfirmationModalState] = useState(false)
  const [finishModalState, setFinishModalState] = useState(false)
  const [isPasswordMatch, setIsPasswordMatch] = useState(false)
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))

  useEffect(() => {
    const isMatch = isNotEmpty(newPassword) && isNotEmpty(repeatPassword) &&
    newPassword === repeatPassword;

    setIsPasswordMatch(isMatch)
    setIsFormNotValid(validPassword && isMatch && (isResetAdmin ? true : isNotEmpty(password)))
  }, [password, newPassword, repeatPassword, validPassword])

  const submitHandler = async () => {
    setConfirmationModalState(true)
  }

  function handleClose() {
    setFormModalState(false)
  }

  function confirmHandler() {
    const actionTpDispatch = isResetAdmin ? userCustomerAdminAuthChangePassword
      : userAuthChangePassword

    dispatch(
      actionTpDispatch({
        queries: {
          ...(!isResetAdmin ? { old_password: password } : {}),
          new_password: newPassword,
        },
        userId,
      }),
    ).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setFinishModalState(true)
      }
    })
  }

  const FinishHandler = () => {
    setFinishModalState(false)
    handleClose()
  }

  return (
    <Box>
    <FormModalContainer
      modalState={formModalState}
      handleClose={handleClose}
        modalTitle={isResetAdmin ? `${t?.[resetPasswordModalData.header]}` : `${t?.[changePasswordModalData.header]}`}
        modalSubTitle={isResetAdmin ? `${t?.[resetPasswordModalData.subHeader]}` : `${t?.[changePasswordModalData.subHeader]}`}
        mediumSize
      >

      <Box sx={styles.formContainer}>
        {!isResetAdmin &&
        <OfoqPasswordField
        defaultValue={password}
        refState={setPassword}
        placeholder={t?.['Enter the Old Password']}
        name={t?.['old password']}
        hideInputValidator
        required
        />
      }

        <OfoqPasswordField
          defaultValue={newPassword}
          refState={setNewPassword}
          placeholder={t?.['Enter the new password']}
          name={t?.['new password']}
          setValidPassword={setValidPassword}
          hideInputValidator={false}
          required
        />

        <OfoqPasswordField
          defaultValue={repeatPassword}
          refState={setRepeatPassword}
          placeholder={t?.['Repeat the New Password']}
          name={t?.['Repeat New Password']}
          hideInputValidator
          required
          passwordMatch={isPasswordMatch}
        />

      </Box>

      <Box sx={styles.formModalBtnsContainer}>
          {!isXsScreen && <OfoqThemeBtn cancelStyle
            onClick={handleClose}
            name={t?.cancel}
            customStyle={styles.actionBtn} />
          }
          <OfoqThemeBtn
            disabled={!isFormNotValid}
            onClick={submitHandler}
            name={t?.save}
            customStyle={styles.actionBtn}
            />
      </Box>
    </FormModalContainer>

    <ConfirmationModalContainer
        modalState={confirmationModalState}
        setModalState={setConfirmationModalState}
        setFinishModalState={setFinishModalState}
        confirmationData={isResetAdmin
          ? resetPasswordModalData : changePasswordModalData}
        confirmHandlerQueries={{}}
        functionToDispatch={confirmHandler}
        cancelText={t?.Back}
      />

      <FinishModalContainer
        modalState={finishModalState}
        modalChangeState={setFinishModalState}
        finishHandler={FinishHandler}
        modalTitle={isResetAdmin ? resetPasswordModalData.header : changePasswordModalData.header}
        modalMessage={isResetAdmin
          ? resetPasswordModalData.message
          : changePasswordModalData.message}
          messageCustomStyle={styles.messageCustomStyle}
      />
  </Box>

  )
}

const styles = {
  root: {
    '& header': {
      marginBottom: '0px',
    },
  },
  formModalBtnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: { xs: '10px -10px 0 -10px', sm: '0px -15px 0 -15px' },
    padding: { xs: '10px 10px 0', md: '15px 15px 0' },
    borderTop: '1px solid #cbcbcb',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '10px !important',
  },
  actionBtn: {
    fontSize: { xs: '12px', sm: '14px' },
    maxWidth: { xs: '100%', sm: '100px !important' },
    height: '40px !important',

    '&:disabled': {
      backgroundColor: '#E0E0E0',
    },
  },
  messageCustomStyle: {
    maxWidth: { xs: '180px !important', sm: '215px !important', xl: '200px !important' },
  },
}

export default ChangePasswordModal
